import { template as lodashTemplate } from 'lodash';
import { useMemo } from 'react';
import { ICreator } from '~/types';

import { MESSAGE_TEMPLATES, TEMPLATE_METADATA } from './constants';

export const useMessageTemplates = (creator: ICreator | null) => {
  return useMemo(() => {
    if (!creator) return [];

    const variables = {
      managerName: creator.manager?.name || '',
      creatorName: creator.fullName || '',
    };

    return TEMPLATE_METADATA.map((template) => {
      const templateString =
        MESSAGE_TEMPLATES[template.id as keyof typeof MESSAGE_TEMPLATES];
      const formattedTemplate = lodashTemplate(templateString, {
        interpolate: /{{([\s\S]+?)}}/g,
      });
      const message = formattedTemplate(variables);

      return {
        ...template,
        message,
      };
    });
  }, [creator]);
};
